import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
  data: [],
  currentBlog: null,
  message: ''
};

export const blogSlice = createSlice({
  name: 'blogSliceName',
  initialState,
  reducers: {
    getBlogs: (state) => {
      state.loading = true;
    },
    getOneBlog: (state) => {
      state.loading = true;
    },
    addBlog: (state) => {
      state.loading = true;
    },
    updateBlog: (state) => {
      state.loading = true;
    },
    removeBlog: (state) => {
      state.loading = true;
    },
    successBlogs: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    successOneBlog: (state, action) => {
      state.loading = false;
      state.currentBlog = action.payload;
    },
    failedBlogs: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    }
  }
});

export const { getBlogs, getOneBlog, addBlog, updateBlog, removeBlog, successBlogs, successOneBlog, failedBlogs } = blogSlice.actions;

export default blogSlice.reducer;
